document.addEventListener("DOMContentLoaded", () => {
  const burgerButton = document.getElementById("burgerButton");
  const line1 = document.getElementById("line1");
  const line2 = document.getElementById("line2");
  const nav = document.getElementById("nav");
  const header = document.getElementById("header");

  if (!burgerButton || !line1 || !line2 || !nav || !header) {
    return;
  }

  const handler = () => {
    if (burgerButton.dataset.page == "home") {
      header.classList.toggle("bg-opacity-70");
    }

    if (
      line1.classList.contains("rotate-45") &&
      line2.classList.contains("-rotate-45")
    ) {
      line1.classList.remove("rotate-45", "transform", "translate-y-1.5");
      line2.classList.remove("-rotate-45");
      nav.classList.remove("flex");
      nav.classList.add("hidden");
      // document.body.classList.remove("h-screen", "overflow-hidden");
    } else {
      line1.classList.add("rotate-45", "transform", "translate-y-1.5");
      line2.classList.add("-rotate-45");
      nav.classList.remove("hidden");
      nav.classList.add("flex");
      // document.body.classList.add("h-screen", "overflow-hidden");
    }
  };

  burgerButton.addEventListener("click", handler);
  burgerButton.addEventListener("keydown", handler);
});
